// Candy confetti: a small burst of candy-coloured pieces from the click point on any candy button, plus a "Great choice!" sticker on add-to-cart buttons.
// Decorative only; skipped for reduced motion. Pieces are fixed-position, ignore the pointer, and remove themselves.
const BUTTON_SELECTOR = '.button-primary, .button-secondary, .button-surface';
const COLOURS = ['red', 'orange', 'yellow', 'green', 'blue', 'purple', 'pink'];
const PIECES = 18;
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

// Pop-ups (modal dialogs) sit in a layer above the whole page, so effects for buttons inside an open pop-up are added to that pop-up instead of the page.
function effectHost(button) {
  return button.closest('dialog[open]') || document.body;
}

function burst(viewportX, viewportY, host = document.body) {
  const layer = document.createElement('div');
  layer.setAttribute('aria-hidden', 'true');
  layer.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:2147483000;overflow:hidden;';
  host.append(layer);
  // Inside an animated pop-up the layer may be positioned relative to the pop-up, so convert the click point to the layer's own coordinates.
  const origin = layer.getBoundingClientRect();
  const x = viewportX - origin.left;
  const y = viewportY - origin.top;

  const animations = [];
  for (let i = 0; i < PIECES; i += 1) {
    const piece = document.createElement('span');
    const size = 6 + Math.random() * 6;
    const round = Math.random() < 0.4;
    const colour = COLOURS[i % COLOURS.length];
    piece.style.cssText = `position:absolute;left:${x}px;top:${y}px;width:${size}px;height:${round ? size : size * 0.5}px;` +
      `background:var(--color-candy-${colour});border-radius:${round ? '9999px' : '2px'};translate:-50% -50%;`;
    layer.append(piece);

    const angle = (Math.PI * 2 * i) / PIECES + (Math.random() - 0.5) * 0.6;
    const distance = 40 + Math.random() * 50;
    const dx = Math.cos(angle) * distance;
    const dy = Math.sin(angle) * distance;
    const spin = (Math.random() - 0.5) * 720;
    animations.push(piece.animate([
      { transform: 'translate(0, 0) rotate(0deg) scale(1)', opacity: 1 },
      { transform: `translate(${dx}px, ${dy}px) rotate(${spin / 2}deg) scale(1)`, opacity: 1, offset: 0.6 },
      { transform: `translate(${dx * 1.1}px, ${dy * 1.1 + 30}px) rotate(${spin}deg) scale(0.6)`, opacity: 0 },
    ], { duration: 700 + Math.random() * 300, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)', fill: 'forwards' }).finished);
  }
  Promise.allSettled(animations).then(() => layer.remove());
}

// "Great choice!" sticker: pops up from add-to-cart buttons alongside the confetti, floats up a little and fades.
// The wording comes from the body's data-great-choice attribute (locale key general.great_choice).
// Includes the add buttons in the checkout "Fancy a little extra?" pop-up (data-upsell-add).
const ADD_SELECTOR = 'button[name="add"], input[name="add"], [data-upsell-add]';

function greatChoice(x, y, host = document.body) {
  const message = document.body.dataset.greatChoice;
  if (!message) return;
  const sticker = document.createElement('div');
  sticker.setAttribute('aria-hidden', 'true');
  sticker.className = 'great-choice type-display';
  sticker.textContent = message;
  // Keep it on screen near the click, above the button.
  const left = Math.min(Math.max(x, 90), window.innerWidth - 90);
  const top = Math.max(y - 56, 40);
  sticker.style.left = '0px';
  sticker.style.top = '0px';
  host.append(sticker);
  // Measure where (0, 0) lands (the pop-up may be the positioning box), then place the sticker at the click point.
  const probe = sticker.getBoundingClientRect();
  sticker.style.left = `${left - (probe.left + probe.width / 2)}px`;
  sticker.style.top = `${top - probe.top}px`;

  const keyframes = reducedMotion.matches
    ? [{ opacity: 0 }, { opacity: 1, offset: 0.15 }, { opacity: 1, offset: 0.8 }, { opacity: 0 }]
    : [
        { opacity: 0, transform: 'translate(-50%, 10px) scale(0.4) rotate(-12deg)' },
        { opacity: 1, transform: 'translate(-50%, -6px) scale(1.12) rotate(4deg)', offset: 0.18 },
        { opacity: 1, transform: 'translate(-50%, -10px) scale(1) rotate(-3deg)', offset: 0.3 },
        { opacity: 1, transform: 'translate(-50%, -22px) scale(1) rotate(-3deg)', offset: 0.8 },
        { opacity: 0, transform: 'translate(-50%, -34px) scale(0.92) rotate(-3deg)' },
      ];
  sticker.animate(keyframes, { duration: 1500, easing: 'cubic-bezier(0.2, 0.8, 0.3, 1)', fill: 'forwards' }).finished
    .finally(() => sticker.remove());
}

document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest(BUTTON_SELECTOR) : null;
  if (!button || button.matches(':disabled, [aria-disabled="true"]')) return;
  const rect = button.getBoundingClientRect();
  // Keyboard clicks report 0,0; burst from the button's centre instead.
  const fromPointer = event.clientX !== 0 || event.clientY !== 0;
  const x = fromPointer ? event.clientX : rect.left + rect.width / 2;
  const y = fromPointer ? event.clientY : rect.top + rect.height / 2;
  const host = effectHost(button);
  if (button.matches(ADD_SELECTOR)) greatChoice(x, rect.top, host);
  if (reducedMotion.matches) return;
  burst(x, y, host);
}, { capture: true, passive: true });
